export const visit = (vm, at) => {
at({ "es": { "priceComponents": { "pricePerMonth": "{{price}}/mes", "pricePerMonth_New": "{{price}} al mes", "pricePerMonthPerSeat": "{{price}}/mes/licencia", "pricePerMonthPerSeat_New": "{{price}} al mes por licencia", "subtexts": { "startsAt": "Desde" } } } });
};